import React from 'react';
import { Search } from 'lucide-react';
import { useTranslation } from "react-i18next";

/**
 * SearchBar Component
 * Provides search input with icon
 */
export default function SearchBar({ 
  value, 
  onChange, 
  placeholder,
  className = "admin-users-search",
  disabled = false
}) {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <Search className="admin-users-search-icon" size={18} />
      <input
        type="text"
        className="admin-users-search-input"
        placeholder={placeholder || t("admin.common.search")}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
}
